import React from 'react'

const Glossary = ({
  glossaries  = [],
  notes     = []
}) => {
  return (
    <div className="glossary">
      { 
        notes.map((item,i) => {
          return (
            <p key={i} dangerouslySetInnerHTML={{ __html: item }} />
          )
        })
      }
      {
        glossaries.length && <h3>Glossary</h3> || ''
      }
      <ul>
        { 
          glossaries.map((item,i) => {
            return (
              <li key={i} dangerouslySetInnerHTML={{ __html: `<span>${item.title}:</span> ${item.description}` }} />
            )
          })
        }
      </ul>
    </div>
  )
}

export default Glossary



/** WEBPACK FOOTER **
 ** ../app/components/common/Glossary.jsx
 **/